module.exports = __webpack_public_path__ + "img/HomePage-media.643316a.webp";